import { Root } from '@athena/forge';
import React from 'react';
import Banner from '../common/Banner';

/**
 * V2 of PasswordRequirements component with Forge Banner styling
 * Features:
 * - Purple left border with info icon
 * - Bold header text
 * - Clean list without bullets
 * - Modern, elevated design matching Forge design system
 */
export default function PasswordRequirementsV2 ({
  passwordRequirements,
  headerSelector = '.password-requirements--header',
  itemListSelector = '.password-requirements--list',
}: {
  passwordRequirements: JQuery<HTMLElement>;
  headerSelector?: string;
  itemListSelector?: string;
}) {
  const headerText = passwordRequirements.find(headerSelector).text();
  const items = passwordRequirements.find(itemListSelector).children();

  return (
    <Root>
      <Banner alertType="info" headerText={headerText}>
        <ul>
          {items.map((index, element) => {
            return (
              <li key={index}>
                {items.eq(index).text()}
              </li>
            );
          })}
        </ul>
      </Banner>
    </Root>
  );
}
